import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=059c0e14&"
import script from "./OrganizationPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPage.vue?vue&type=style&index=0&id=059c0e14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports